import CartProvider from '@jetshop/core/components/Query/CartProvider';
import t from '@jetshop/intl';
import Drawer, { DrawerTarget } from '@jetshop/ui/Modal/Drawer';
import { Price } from '@jetshop/ui/Price';
import { theme } from '../Theme';
import get from 'lodash.get';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { styled } from 'linaria/react';
import UIButton from '../ui/Button';
import CartItem from './CartItem';
import cartQuery from './CartQuery.gql';
import ChannelContext from '@jetshop/core/components/ChannelContext';

import { VoyadoTracking } from '../MyPages/VoyadoTracking';
import CartRecommendations from './Recommendations/CartRecommendations';
import { DynamicCategoryRenderer } from '../StartPage/ContentRendererComponents/DynamicCategoryRenderer/DynamicCategoryRenderer';
import { cartComponents } from '../StartPage/ContentRendererComponents/allcomponents';
import { useVoyadoTracker } from '../../useVoyadoTracker';
import { useTracking } from '../../utils/tracking/useTracking';
import ShareCart from './ShareCart';
import { useElevate } from '../Elevate/ElevateContext';
import { ElevateRecommendationsHandler } from '../Elevate/pdp/ElevateRecommendationsHandler';

export const Flyout = styled('div')`
  color: ${theme.colors.primary};
  position: absolute;
  z-index: 999;
  right: 0;
  top: 0;
  width: 100%;
  max-width: 100%;
  height: calc(100% - 6.3rem);
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0px;
  }

  ${theme.below.lg} {
    top: 0;
    height: calc(100%);
  }

  .elevate-recommendations-title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .elevate-product-card {
    .elevate-product-card-content {
      .price {
        font-size: 14px;
        line-height: 1;
        .currency {
          font-size: 12px;
          line-height: 1;
          margin-bottom: 0;
        }
      }
    }
  }
`;

export const CartButtons = styled('div')`
  display: flex;
  button {
    background: none;
    transition: all, 0.2s ease;
    &:hover {
      background: #f4f4f4;
    }
  }
`;
export const CartTopButton = styled('div')`
  width: 50%;
  text-align: center;
  padding: 20px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;
  &:first-child {
    border-left: 0;
  }
  &.active {
    border-bottom: 3px solid #181818;
  }
`;

const CartHeader = styled('h2')`
  text-align: center;
  font-size: 1rem;
  margin-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dddddd;
`;

const CartItems = styled('section')`
  padding: 0;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

const ShareLinkWrapper = styled('div')`
  padding: 0 1.5rem;
  text-align: right;
`;

export const Summary = styled('section')`
  background: #fff;
  padding: 20px;

  a {
    width: 100%;
    color: white;
    :hover {
      color: white;
    }
  }
`;

export const TotalSummary = styled('div')`
  font-size: 1.25rem;
  color: ${theme.colors.primary};
  display: flex;
  justify-content: center;
  margin-bottom: 3px;
  label {
  }
  > div {
    font-weight: 500;
  }
`;

export const Checkout = styled('a')`
  background-color: ${theme.colors.accent};
  display: block;
  margin-bottom: 0.5rem;
  justify-content: center;
  padding: 0.6rem 0.5rem;
  text-align: center;
  text-decoration: none !important;
  text-transform: uppercase;
  width: 100% !important;
  font-family: ${theme.fonts.body};
  font-weight: bold;
  border: 2px solid ${theme.colors.accent};
  box-sizing: border-box;
  &:hover {
    color: ${theme.colors.accent}!important;
    background: white;
  }
`;

export const UspContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
`;

export const UspItem = styled('div')`
  display: flex;
  align-items: center;
  color: #a2a2a2;
  padding: 0 20px;
`;

export const UspText = styled('span')`
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 300;
`;

export const CartFlyoutOuter = styled('div')`
  > div {
    overflow: hidden;
    ${theme.above.xl} {
      margin-top: 100px;
    }
    ${theme.below.xl} {
      margin-top: 116px;
      height: calc(100% - 116px);
    }
    ${theme.below.lg} {
      margin-top: 92px;
      height: calc(100% - 92px);
      overflow: hidden;
    }
    ${theme.below.md} {
      margin-top: 136px;
      height: calc(100% - 136px);
    }
    ${theme.below.sm} {
      margin-top: 60px;
      height: calc(100% - 60px);
    }
  }
`;

const Button = styled(UIButton)`
  font-size: 14px;
  margin-top: 0.5rem;
  outline: none;
  text-align: center;
  transition: all ease 0.3s;
  width: 100% !important;
  max-width: 100%;
  font-weight: bold;
  margin-bottom: 1rem;
  background: #ddd;
  height: 42px;
  line-height: 42px;
  border: 2px solid #ddd;
  display: block;
  &:hover {
    background: #c8c8c8;
  }
`;

const VatDetails = styled('div')`
  color: #666666;
  display: flex;
  font-size: 14px;
  justify-content: center;
  margin-bottom: 2rem;
  text-align: center;
`;

const Discounts = styled('div')`
  color: ${theme.colors.red};
  font-size: 0.75rem;
  margin-bottom: 2rem;
  .price::before {
    content: '-';
  }
  > div {
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
  }
`;

const ElevateCartRecommendationsWrapper = styled('div')`
  max-width: 100%;
  padding: 0 10px;

  > div {
    margin-top: 0px;
  }
`;

const CartFlyoutView = ({ result, modal, ...rest }) => {
  const { trackViewMiniCart, trackBeginCheckout } = useTracking();
  const items = get(result, 'data.cart.items', []);
  const checkoutUrl = get(result, 'data.cart.externalCheckoutUrl');
  useVoyadoTracker();
  const { selectedChannel } = useContext(ChannelContext);
  const { getCartPageData } = useElevate();
  const [cartPageData, setCartPageData] = useState(null);
  useEffect(() => {
    const fetchCartPageData = async () => {
      const response = await getCartPageData({
        cartProductKeys: items?.map(item => item.articleNumber)
      });

      setCartPageData(response);
    };
    fetchCartPageData();
  }, [items]);
  // Ref to track previous isOpen state - prevents duplicate tracking on cart updates
  const prevIsOpenRef = useRef(false);

  // Track view_mini_cart only when cart drawer is OPENED (not on every cart update)
  useEffect(() => {
    // Only track when transitioning from closed to open
    if (modal.isOpen && !prevIsOpenRef.current && result.data?.cart) {
      trackViewMiniCart({
        cart: result.data.cart
      });
    }
    prevIsOpenRef.current = modal.isOpen;
  }, [modal.isOpen, result.data?.cart, trackViewMiniCart]);

  const handleBeginCheckout = e => {
    e.preventDefault();

    // Track begin_checkout
    trackBeginCheckout({
      cart: result.data.cart
    });

    // Navigate to checkout after tracking
    setTimeout(() => {
      window.location.href = checkoutUrl;
    }, 100);
  };

  const VAT = new Intl.NumberFormat(selectedChannel.defaultLanguage.culture, {
    style: 'currency',
    currency: selectedChannel.currency.name
  }).format(result.data.cart.productTotal.vat);
  let discounts = result?.data?.cart?.aggregatedDiscounts;
  if (discounts && discounts.length > 0) {
    discounts = discounts.filter(camp => !camp.name.startsWith('*'));
  }

  return (
    <Flyout {...rest}>
      <VoyadoTracking cart={result.data.cart} />
      <CartHeader>{t('Your shopping cart')}</CartHeader>
      <CartItems>
        {items.map(item => (
          <CartItem hideTarget={modal.hideTarget} item={item} key={item.id} />
        ))}
      </CartItems>
      <ShareLinkWrapper>
        <ShareCart items={items} textLink />
      </ShareLinkWrapper>

      <Summary>
        {discounts && discounts.length > 0 && (
          <Discounts>
            {discounts.map(discount => (
              <div key={discount.name}>
                <strong>{discount.name}</strong>
                <Price price={discount.value} />
              </div>
            ))}
          </Discounts>
        )}
        <TotalSummary>
          <label>{t('Total')}:&nbsp;</label>
          <Price price={result.data.cart.productTotal} />
        </TotalSummary>
        <VatDetails>
          <label>{t('of which VAT')}:&nbsp;</label>
          {VAT}
        </VatDetails>
        {checkoutUrl && (
          <Checkout href={checkoutUrl} onClick={handleBeginCheckout}>
            {t('Check out')}
          </Checkout>
        )}
        <Button onClick={modal.hideTarget}>{t('Continue shopping')}</Button>

        {/* <DynamicCategoryRenderer
          categoryId={3285}
          rendererComponents={cartComponents}
        /> */}
      </Summary>
      <ElevateCartRecommendationsWrapper>
        <ElevateRecommendationsHandler
          title={t('See also')}
          slidesToShowDesktop={2}
          slidesToShowMobile={2}
          showVariants={false}
          clickCallback={modal.hideTarget}
          recommendationsLists={cartPageData?.recommendationLists}
        />
      </ElevateCartRecommendationsWrapper>
    </Flyout>
  );
};

const CartFlyout = props => (
  // Wrap the flyout with the needed providers
  <CartFlyoutOuter>
    <CartProvider query={cartQuery}>
      {result =>
        result.data && result.data.cart ? (
          <DrawerTarget id="cart-drawer">
            {drawer => (
              <Drawer isOpen={drawer.isOpen} right size={500}>
                {drawer.isOpen && (
                  <CartFlyoutView modal={drawer} result={result} {...props} />
                )}
              </Drawer>
            )}
          </DrawerTarget>
        ) : null
      }
    </CartProvider>
  </CartFlyoutOuter>
);

export default CartFlyout;
